import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CopyContentItemDocument } from './copy.generated';

export const useCopyContentItem = (options: ApiOptions<typeof CopyContentItemDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CopyContentItemDocument, {
    ...useNotifications(CopyContentItemDocument, {
      failure: t('api.content_items.copy_error'),
      success: t('api.content_items.copy_success'),
    }),

    ...options,
  });
};
